import classnames from 'classnames'
import Offer from 'entities/offer'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import 'styles/components/offer-selector.scss'

const Options = ({ offers, onSelect }) => {
  const options = offers.map(offer => {
    const style = {
      backgroundImage: offer.coverUrl ? `url(${offer.coverUrl})` : null
    }

    return (
      <div key={offer.id} className="offer-selector-option" onClick={() => onSelect(offer)} role="presentation">
        {offer.coverUrl !== null ? <div className="cover" style={style} /> : null}
        <div className="titles">
          <div className="scout-title">{offer.scoutTitle}</div>
          <div className="position">{offer.position}</div>
        </div>
      </div>
    )
  })

  return (
    <div className="offer-selector-options">
      <div className="offer-selector-options-in">{options}</div>
    </div>
  )
}

Options.propTypes = {
  offers: PropTypes.arrayOf(PropTypes.instanceOf(Offer)).isRequired,
  onSelect: PropTypes.func.isRequired
}

export default class OfferSelector extends Component {
  constructor(props) {
    super(props)

    this.state = {
      show: false
    }
  }

  showSelector() {
    this.setState({
      show: true
    })
  }

  hideSelector() {
    this.setState({
      show: false
    })
  }

  handleSelectOffer(offer) {
    this.props.onChange(offer)
    this.hideSelector()
  }

  render() {
    const { selected, offers } = this.props
    const { show } = this.state

    const className = classnames('offer-selector', {
      'is-active': show
    })

    const buttonClassName = classnames('btn btn-selector', {
      'is-active': selected !== null
    })

    return (
      <div className={className}>
        <button type="button" className={buttonClassName} onClick={() => this.showSelector()}>
          {(selected && selected.scoutTitle) || I18n.t('components.offer_selector.button.select')}
          <div className="caret" />
        </button>
        <div className="offer-selector-bg" onClick={() => this.hideSelector()} role="presentation" />
        {show ? <Options offers={offers} onSelect={offer => this.handleSelectOffer(offer)} /> : null}
      </div>
    )
  }
}

OfferSelector.propTypes = {
  selected: PropTypes.instanceOf(Offer),
  offers: PropTypes.arrayOf(PropTypes.instanceOf(Offer)).isRequired,
  onChange: PropTypes.func.isRequired
}

OfferSelector.defaultProps = {
  selected: null
}
